var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class PeriodVersionActions {
  constructor(_data) {
    /**
     */
    __publicField(this, "CanRegenerateFiles");
    /**
     */
    __publicField(this, "CanStartCorrection");
    /**
     */
    __publicField(this, "CanUploadCesopResponse");
    /**
     */
    __publicField(this, "CanUploadProofFile");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PeriodVersionActions
     */
    __publicField(this, "$type", "V1.Cesop.Periods.PeriodVersionActions");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CanRegenerateFiles = _data["CanRegenerateFiles"];
      this.CanStartCorrection = _data["CanStartCorrection"];
      this.CanUploadCesopResponse = _data["CanUploadCesopResponse"];
      this.CanUploadProofFile = _data["CanUploadProofFile"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CanRegenerateFiles"] = this.CanRegenerateFiles;
    _data["CanStartCorrection"] = this.CanStartCorrection;
    _data["CanUploadCesopResponse"] = this.CanUploadCesopResponse;
    _data["CanUploadProofFile"] = this.CanUploadProofFile;
    return _data;
  }
}
